import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ background: 'var(--dark-2)', borderTop: '1px solid var(--dark-4)', padding: '48px 20px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="grid-3" style={{ marginBottom: 32 }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="var(--volt)"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
              <span style={{ fontFamily: "'Space Grotesk'", fontWeight: 700, fontSize: 16 }}>eBikeDubai<span style={{ color: 'var(--volt)' }}>.ae</span></span>
            </div>
            <p style={{ color: 'var(--text-2)', fontSize: 13, lineHeight: 1.6 }}>Dubai's premier electric bike marketplace. Buy, sell, and trade Surron, Talaria, Kugoo & electric scooters.</p>
          </div>
          <div>
            <h4 style={{ fontSize: 13, color: 'var(--volt)', marginBottom: 12, textTransform: 'uppercase', letterSpacing: 1 }}>Browse</h4>
            <Link to="/buy" className="nav-link" style={{ display: 'block', marginBottom: 8, fontSize: 13, textDecoration: 'none' }}>All E-Bikes</Link>
            <Link to="/surron-dubai" className="nav-link" style={{ display: 'block', marginBottom: 8, fontSize: 13, textDecoration: 'none' }}>Surron Dubai</Link>
            <Link to="/talaria-dubai" className="nav-link" style={{ display: 'block', marginBottom: 8, fontSize: 13, textDecoration: 'none' }}>Talaria Dubai</Link>
            <Link to="/electric-scooters-dubai" className="nav-link" style={{ display: 'block', marginBottom: 8, fontSize: 13, textDecoration: 'none' }}>Electric Scooters</Link>
          </div>
          <div>
            <h4 style={{ fontSize: 13, color: 'var(--volt)', marginBottom: 12, textTransform: 'uppercase', letterSpacing: 1 }}>Contact</h4>
            <p style={{ color: 'var(--text-2)', fontSize: 13, marginBottom: 8 }}>WhatsApp: +971 58 533 8786</p>
            <p style={{ color: 'var(--text-2)', fontSize: 13, marginBottom: 8 }}>Email: info@ebikedubai.ae</p>
            <p style={{ color: 'var(--text-2)', fontSize: 13 }}>Dubai, UAE</p>
          </div>
        </div>
        <div style={{ borderTop: '1px solid var(--dark-4)', paddingTop: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <p style={{ color: 'var(--text-3)', fontSize: 12 }}>© 2026 ebikedubai.ae — All rights reserved</p>
          <Link to="/admin" className="nav-link" style={{ fontSize: 11, color: 'var(--text-3)', textDecoration: 'none' }}>Admin</Link>
        </div>
      </div>
    </footer>
  );
}
